<template>
  <div
    ref="helperTourActive"

    class="customizer d-none d-md-block"
  >
    <!-- Toggler -->
    <b-link
      id="helper-tour-active"
      class="customizer-toggle d-flex align-items-center justify-content-center"
      @click="startHelper"
    >
      <feather-icon
        icon="HelpCircleIcon"
        size="15"
      />
    </b-link>
    <!-- /Toggler -->
  </div>
</template>

<script>
import {
  BLink,
} from 'bootstrap-vue'
import useAppHelperTour from './useAppHelperTour'

export default {
  components: {
    // BSV
    BLink,
  },
  data() {
    return {
     flagWatch: false,
    }
  },
  computed: {
    isTypeHelperTour() {
      return this.$store.getters['appHelperTour/typeHelperTour'] !== null
    },
  },
  methods: {
    startHelper() {
      this.$nextTick(async () => {
        if (!this.isTypeHelperTour) {
          this.flagWatch = !this.flagWatch
          this.$tours.vuexyTour.skip()
          return
        }
        this.flagWatch = !this.flagWatch
        await this.startHelperTour()
        this.$tours.vuexyTour.start()
      })
    },
  },
  setup() {
    const {
      isOpenHelperTour,
      toogleAppHelperTour,
      startHelperTour,
    } = useAppHelperTour()

    return {
      isOpenHelperTour,
      toogleAppHelperTour,
      startHelperTour,

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.customizer-section {
  padding: 1.5rem;
    border-bottom: 1px solid #ebe9f1;

  .dark-layout & {
    border-color: $theme-dark-border-color;
  }

  #skin-radio-group ::v-deep {
    .custom-control-inline {
      margin-right: 0.7rem;
    }
  }

  .form-group {
    margin-bottom: 1.5rem;;
    &:last-of-type {
    margin-bottom: 0;
    }
    ::v-deep legend {
      font-weight: 500;
    }
  }
}

.mark-active {
  box-shadow: 0 0 0 0.2rem rgba(38,143,255,.5);
}

.ps-customizer-area {
  height: calc(100% - 83px)
}
</style>
